Date.prototype.formatMMDDYYYY = function () {
    return this.getDate() +
        "/" + (this.getMonth() + 1) +
        "/" + this.getFullYear();
};

var Aurelium = {
    Validate:
        {
            IsNumeric: function (text) {
                return !isNaN(text);
            },
            IsNullOrEmpty: function (value) {
                return value === undefined || value === null || value === '';
            },
            NumberInRange: function (number, minValue, maxValue) {
                return number >= minValue && number <= maxValue;
            },
            IsEmail: function (email) {
                var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return re.test(email);
            },
            StringEndsWith: function (string, endsWithText) {
                return string.toLowerCase().indexOf(endsWithText.toLowerCase(), string.length - endsWithText.length) !== -1;
            }
        },
    Net:
        {
            GetQueryStringValueByName: function (parameterName) {
                parameterName = parameterName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + parameterName + "=([^&#]*)"),
                results = regex.exec(location.search);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            },
            RedirectToSourceUrl: function () {
                var SourceUrl = Aurelium.Net.GetQueryStringValueByName("Source");
                if (SourceUrl !== '') {
                    window.location = SourceUrl;
                }
                else {
                    window.location = _spPageContextInfo.webServerRelativeUrl;
                }
            }
        },
    MVC: {
        Forms: {
            AddMaxLength: function () {
                $("input[data-val-length-max]").each(function () {
                    $(this).attr("maxlength", $(this).attr("data-val-length-max"));
                });
            },
            AddRequiredFields: function () {
                $("input[data-val-required]").not("input[type='hidden']").each(function () {
                    $(this).closest("div.form-group").find('label').append("<span style='color: red; font-size: 0.9em;'>*</span>");
                });
                $("select[data-val-required]").not("select[type='hidden']").each(function () {
                    $(this).closest("div.form-group").find('label').append("<span style='color: red; font-size: 0.9em;'>*</span>");
                });
                $("textarea[data-val-required]").not("textarea[type='hidden']").each(function () {
                    $(this).closest("div.form-group").find('label').append("<span style='color: red; font-size: 0.9em;'>*</span>");
                });
                
            }
        }
    }
}

// Expose to global scope (required for IIFE bundle format)
window.Aurelium = Aurelium
